import { useQuery } from 'react-query';
import { useMemo } from 'react';
import { getGeneralInfoById } from 'apis/projectProposals.api';

const useGetGeneralInfoById = (id, conds) => {
  const { data: generalInfoData, ...rest } = useQuery(
    ['projectProposal-generalInfo', id],
    () => getGeneralInfoById(id),
    {
      ...conds,
    }
  );
  const generalInfo = useMemo(() => generalInfoData?.data ?? {}, [generalInfoData]);

  return {
    data: generalInfo,
    ...rest,
  };
};

export default useGetGeneralInfoById;
